module.exports = __webpack_public_path__ + "img/sp-lp-workout.7f0ef765.jpg";